import * as Yup from 'yup';

export const divisionFormSchema = Yup.object().shape({
  divisionName: Yup.string().required('Name is required'),
});
